import * as React from "react";
const SvgFiRrFaceThinking = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-thinking_svg__a)">
      <path
        fill="#062147"
        d="M17.001 22.801a1 1 0 0 1-.456-1.891A9.97 9.97 0 0 0 22 12c0-5.514-4.486-10-10-10S2 6.486 2 12a9.94 9.94 0 0 0 1.817 5.75 1 1 0 0 1-1.635 1.152A11.93 11.93 0 0 1 0 12C0 5.383 5.383 0 12 0s12 5.383 12 12c0 4.531-2.508 8.627-6.545 10.691a1 1 0 0 1-.454.109zM8.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 8.5 8m7 1a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 15.5 9m-4.126-1.073a1 1 0 0 0 .554-1.302C11.533 5.65 10.368 4 8.5 4c-1.444 0-2.398.929-2.734 1.478a.99.99 0 0 0 .319 1.356 1.01 1.01 0 0 0 1.377-.297A1.27 1.27 0 0 1 8.5 6c.966 0 1.562 1.348 1.574 1.379a1 1 0 0 0 1.3.548m-2.261 5.945a1 1 0 0 1 .886 1.463l-.482.921 6.196-1.955a.99.99 0 0 1 1.242.649.99.99 0 0 1-.649 1.242l-2.302.721-.005 5.029a1.5 1.5 0 0 1-1.026 1.422l-1.309.436a4.3 4.3 0 0 1-3.302-.296c-1.267-.662-2.208-1.945-2.324-3.587-.057-.809.155-1.617.531-2.336l1.659-3.172c.179-.341.527-.537.887-.537z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-thinking_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceThinking;
